const FULL_WIDTH_ALPHANUMERIC_PATTERN = /[０-９Ａ-Ｚａ-ｚ]/g;
const FULL_WIDTH_ASCII_OFFSET = 0xfee0;

/**
 * 全角の英字・数字だけを半角へ変換する。
 * カナや記号など、それ以外の文字は変更しない。
 */
export function normalizeFullWidthAlphanumeric(value) {
  if (typeof value !== "string") return value;

  return value.replace(FULL_WIDTH_ALPHANUMERIC_PATTERN, (character) =>
    String.fromCharCode(character.charCodeAt(0) - FULL_WIDTH_ASCII_OFFSET),
  );
}

